var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page-full-page', {
    staticClass: "app--main"
  }, [_c('full-page', {
    ref: "fullpage",
    attrs: {
      "options": _vm.options,
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "fullpage-section fullpage-section--main"
  }, [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv1-1.jpg"
    }
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-thin"
  }, [_vm._v("함께, 더멀리")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "font-weight-bold"
  }, [_vm._v("모두를 위한 기회를 만듭니다.")])])])])], 1), _c('section', {
    staticClass: "fullpage-section fullpage-section--about",
    staticStyle: {
      "background-image": "url(/images/sub/about/introduction/s1-bg.jpg)"
    }
  }, [_c('div', {
    staticClass: "fullpage-inner pb-0"
  }, [_c('v-container', [_c('div', [_c('v-row', [_c('v-col', {
    staticClass: "d-md-flex align-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "5",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "tit-wrap mb-0 text-left"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold color-point"
  }, [_vm._v(" About us ")]), _c('p', {
    staticClass: "tit-txt color-white"
  }, [_vm._v(" 1995년 설립된 세일즈웍스는 국제적인 네트워크와 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 풍부한 경험을 바탕으로 전문적인 세일즈 & 구독 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 대행 서비스를 제공하는 글로벌 기업입니다. 아시아 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 8개국에 지사를 운영하고 있으며 한국 법인인 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 세일즈웍스 코리아는 전국 주요 도시에 지점을 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 운영하고 있습니다. ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "offset-lg": "1",
      "data-aos": "fade-left"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/about/introduction/map.png",
      "max-width": "582"
    }
  })], 1)], 1)], 1)])], 1)]), _c('section', {
    staticClass: "fullpage-section fullpage-section--wwd",
    staticStyle: {
      "background-image": "url(/images/sub/about/introduction/s1-bg.jpg)"
    }
  }, [_c('div', {
    staticClass: "fullpage-inner"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-n4 mb-md-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "tit-wrap mb-0 text-left"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold color-point"
  }, [_vm._v(" What we do ")]), _c('p', {
    staticClass: "tit-txt color-white"
  }, [_vm._v(" 올바른 가치관을 가진 영업 인재들과 함께 고객사의 상품, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 서비스의 홍보 및 판매를 대행합니다. 비용 대비 높은 성과와 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 안정성을 보장하는 서비스로 다양한 산업 분야의 고객사로부터 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 높은 신뢰를 받고 있습니다. ")])])])], 1)], 1), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "offset-md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('p', {
    staticClass: "tit-txt color-white"
  }, [_vm._v(" 세일즈웍스는 함께하는 모두의 기회 창출을 중요시합니다. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 고객사에게는 사업 성장의 기회를, 구성원에게는 커리어를 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 확장할 수 있는 성장과 발전의 기회를 제공합니다. 기존 사업의 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 고도화, 산업 분야 및 활동 국가 확대, 경쟁력 있는 전문 인재 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 양성을 통해 세일즈웍스는 글로벌 세일즈 플랫폼으로 도약하고 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 있습니다. ")])])], 1)], 1)])], 1)]), _c('section', {
    staticClass: "fullpage-section fullpage-section--support",
    staticStyle: {
      "background-color": "#0c0c0c"
    }
  }, [_c('div', {
    staticClass: "fullpage-section--support__bg",
    attrs: {
      "data-aos": "fade"
    }
  }), _c('div', {
    staticClass: "fullpage-inner"
  }, [_c('v-container', [_c('div', {
    staticClass: "bg-image pa-20 pa-md-30 py-lg-74 px-lg-70 mx-auto mw-100",
    staticStyle: {
      "background-image": "url(/images/sub/about/introduction/s2-txt-bg.jpg)",
      "width": "600px"
    },
    attrs: {
      "data-aos": "zoom-in-up",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "tit-wrap color-white mb-0"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 서포트웍스 ")]), _c('p', {
    staticClass: "tit-txt mt-18 mt-lg-38"
  }, [_vm._v(" 구독서비스, 커머셜 상품, 스타트업 서비스 등 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 다양한 분야와 함께 일해온 세일즈웍스는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 펀드레이징을 전문적으로 전담하는 브랜드 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 서포트웍스를 운영합니다. NGO의 가치와 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 의미를 전달하고 후원자를 연결하는 서포트웍스는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 전문 펀드레이저를 양성하고 파견하며 NGO를 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 위한 토탈 솔루션을 제공합니다. ")]), _c('v-btn', {
    staticClass: "w-lg-220px mt-22 mt-lg-40",
    attrs: {
      "color": "secondary",
      "href": "https://www.supportworks.kr/",
      "target": "_blank"
    }
  }, [_vm._v(" 서포트웍스 홈페이지 ")])], 1)])])], 1)]), _c('div', {
    staticClass: "fullpage-section fullpage-section--etc"
  }, [_c('section', {
    staticClass: "section bg-grey"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 수상내역 ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v(" 세일즈웍스 코리아는 국내외 다양한 부문 수상으로 성과를 인정받으며 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 꾸준히 성장해왔습니다. ")])]), _c('v-row', {
    staticClass: "my-n10 my-lg-n30"
  }, [_c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img1.jpg",
      "year": "2020",
      "tit": "고객감동 우수 브랜드 대상",
      "sc": "중앙일보"
    }
  })], 1), _c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img2.jpg",
      "year": "2019",
      "tit": "고객감동 우수 브랜드 대상",
      "sc": "중앙일보"
    }
  })], 1), _c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img3.jpg",
      "year": "2019",
      "tit": "고객만족 경영 대상",
      "sc": "동아일보"
    }
  })], 1), _c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img4.jpg",
      "year": "2018",
      "tit": "고객감동 우수 브랜드 대상",
      "sc": "중앙일보"
    }
  })], 1), _c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img5.jpg",
      "year": "2018",
      "tit": "Stevie Awards 은상",
      "sc": "Asia-Pacific"
    }
  })], 1), _c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img6.jpg",
      "year": "2018",
      "tit": "Business Awards 은상",
      "sc": "International"
    }
  })], 1), _c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img7.jpg",
      "year": "2017",
      "tit": "Stevie Awards 은상",
      "sc": "Asia-Pacific"
    }
  })], 1), _c('v-col', {
    staticClass: "py-10 py-lg-30",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('award-item', {
    attrs: {
      "src": "/images/sub/about/introduction/s4-img8.jpg",
      "year": "2016",
      "tit": "Stevie Awards 은상",
      "sc": "Asia-Pacific"
    }
  })], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-left"
  }, [_c('v-row', {
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v(" 세일즈웍스의 가치관과 "), _c('br', {
    staticClass: "d-none d-sm-block"
  }), _vm._v(" 방향성을 상징합니다 ")])]), _c('v-spacer'), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "slide-btn-prev",
    attrs: {
      "icon": "",
      "tile": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow2 mr-4 mr-lg-8"
  })]), _c('v-btn', {
    staticClass: "slide-btn-next",
    attrs: {
      "icon": "",
      "tile": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow2"
  })])], 1)], 1)], 1), _c('div', {
    staticClass: "pt-30 pt-lg-54 border-top border-2 border-lg-4 border-color-point w-100"
  }, [_c('div', {
    staticClass: "ci-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "bar-text"
  }, [_vm._v(" CI ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-grey-7 mb-30 mb-lg-54"
  }, [_vm._v(" 세일즈웍스의 로고는 기업의 시각적 정체성 그 이상입니다. 두 부분으로 구성된 심볼은 세일즈웍스의 가치관과 방향성을 나타냅니다. ")]), _c('div', {
    staticClass: "mb-30 mb-lg-32"
  }, [_c('img', {
    staticClass: "w-100 border border-color-light d-none d-md-block",
    attrs: {
      "src": "/images/sub/about/introduction/ci1.jpg",
      "alt": ""
    }
  }), _c('img', {
    staticClass: "w-100 border border-color-light d-block d-md-none",
    attrs: {
      "src": "/images/sub/about/introduction/ci1-mo.jpg",
      "alt": ""
    }
  })]), _c('v-row', {
    staticClass: "ma-sm-n4 ma-lg-n14 text-center"
  }, [_c('v-col', {
    staticClass: "pa-sm-4 pa-lg-14 mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('img', {
    staticClass: "w-100 border border-color-light d-block mb-8 mb-lg-14",
    attrs: {
      "src": "/images/sub/about/introduction/ci1-3.jpg",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 번개를 상징하는 ‘S’ 모양은 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고객 만족을 위한 "), _c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("세일즈웍스의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 강한 에너지를 나타냅니다.")])])]), _c('v-col', {
    staticClass: "pa-sm-4 pa-lg-14 mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('img', {
    staticClass: "w-100 border border-color-light d-block mb-8 mb-lg-14",
    attrs: {
      "src": "/images/sub/about/introduction/ci1-2.jpg",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 상향 화살표는 무한한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 발전을 향해가는 "), _c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("세일즈웍스의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 의지를 나타냅니다.")])])]), _c('v-col', {
    staticClass: "pa-sm-4 pa-lg-14",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('img', {
    staticClass: "w-100 border border-color-light d-block mb-8 mb-lg-14",
    attrs: {
      "src": "/images/sub/about/introduction/ci1-4.jpg",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 두 심볼이 합쳐진 ‘W’ 모양은 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("세일즈웍스의 핵심인 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" WORKS를 상징합니다.")])])])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "mb-50 mb-lg-100"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "bar-text"
  }, [_vm._v(" Color ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('ci-color', {
    attrs: {
      "type": "dark",
      "tit": "THRILLING RED",
      "pantone": "P48-8 C",
      "rgb": "235 / 33 / 43",
      "cmyk": "1 / 99 / 94 / 0",
      "hex": "#eb212b"
    }
  })], 1), _c('v-col', {
    staticClass: "mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('ci-color', {
    attrs: {
      "type": "dark",
      "tit": "STEEL GREY",
      "pantone": "412 C",
      "rgb": "51 / 51 / 51",
      "cmyk": "69 / 63 / 62 / 58",
      "hex": "#333333"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('ci-color', {
    attrs: {
      "tit": "PURE WHITE",
      "pantone": "P48-8 C",
      "rgb": "255 / 255 / 255",
      "cmyk": "0 / 0 / 0 / 0",
      "hex": "#fffff"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "bar-text"
  }, [_vm._v(" Clear Space ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-grey-7 mb-30 mb-lg-54"
  }, [_vm._v(" 로고 주변을 X & Y로 보며, X는 “W”가 상향하는 높이를 뜻합니다. 이 여백에는 다른 글자나 그래픽 요소가 들어가서는 안 됩니다. ")]), _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/about/introduction/ci2.jpg",
      "alt": ""
    }
  })])], 1)], 1)])])])])])])], 1), _c('main-footer')], 1)]), _c('u-scroll-top-full-page')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }